// frontend/src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import '@fortawesome/fontawesome-free/css/all.min.css';

// ============================================
// ARGON DASHBOARD CSS
// ============================================

// Solo importar el CSS principal de Argon
// Nucleo Icons se cargan desde CDN en index.html
import './assets/css/argon-dashboard.css';
import './assets/css/mas-custom.css';
// ============================================
// INICIALIZAR REACT APP
// ============================================

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);
